import { render, staticRenderFns } from "./FeaturedProduct.vue?vue&type=template&id=7f207de9&lang=pug&"
import script from "./FeaturedProduct.vue?vue&type=script&lang=js&"
export * from "./FeaturedProduct.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f207de9')) {
      api.createRecord('7f207de9', component.options)
    } else {
      api.reload('7f207de9', component.options)
    }
    module.hot.accept("./FeaturedProduct.vue?vue&type=template&id=7f207de9&lang=pug&", function () {
      api.rerender('7f207de9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/FeaturedProduct.vue"
export default component.exports